'use client'

import Link from "next/link"
import Cookies from 'js-cookie'
import { useEffect, useState } from "react";
import { useOrgLogo } from "@/hooks/useOrgLogo";

const MainMenu = () => {
    const [userType, setUsetType]: any = useState('')
    const { logo: orgLogo, isLoading: logoLoading } = useOrgLogo();
    // const [isLoafing, setIsLoafing] = useState<boolean>(true)

    useEffect(() => {
        // const authToken = Cookies.get('authToken');
        const userType = Cookies.get('userType');
        setUsetType(userType)
        // setIsLoafing(false)
    }, [])
    // const userType = Cookies.get('userType');

    return (
        <>
            <div>
                <Link href={"/"}>
                    {logoLoading ? (
                        <div className="md:max-w-[450px] h-12 flex items-center justify-center">
                            <svg 
                                className="animate-spin h-8 w-8 text-gray-400" 
                                xmlns="http://www.w3.org/2000/svg" 
                                fill="none" 
                                viewBox="0 0 24 24"
                            >
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </div>
                    ) : (
                        <img 
                            className="md:max-w-[450px]" 
                            src={orgLogo} 
                            alt="hart-college-logo"
                            onError={(e: any) => {
                                e.target.src = "/images/hart-clg-new-logo.png";
                            }}
                        />
                    )}
                </Link>
            </div>

            <nav className="flex gap-3">
                {
                    ((userType == 'user' || userType == 'admin')) ? (
                        <Link href={userType === 'admin' ? '/admin' : '/dashboard'} className="text-lg font-medium cursor-pointer">
                            {userType === 'admin' ? 'Dashboard' : 'Dashboard'}
                        </Link>

                    ) : (
                        <>
                            <Link href="/login" className="text-lg font-medium cursor-pointer">Login</Link>
                            <span>/</span>
                            <Link href="/signup" className="text-lg font-medium cursor-pointer">Signup</Link>
                        </>
                    )
                }
            </nav>
        </>
    )
}

export default MainMenu